import PropTypes from 'prop-types';
import DropdownSelect from 'components/commons/DropdownSelect';
import RpCheckboxOptions from 'components/commons/RpCheckboxOptions';

const RpCheckBoxGroup = function({isDropdown = true, ...props}) {
    const content = (
        <RpCheckboxOptions
            options={props.options}
            selected={props.value}
            onChange={props.onChange}
            title={props.label}
            clearAll={props.clearAll}
            selectAll={props.selectAll}
            columnSize={props.columnSize}
            width={isDropdown ? props.width * 1.625 : '100%'}
            tooltip={props.tooltip}
        />
    );

    return isDropdown ? (
        <DropdownSelect
            label={props.label}
            value={props.displayValue}
            width={props.width || 200}
            active={props.active}
            showValueAsTooltip={props.showValueAsTooltip}
        >
            {content}
        </DropdownSelect>
    ) : content;
};

RpCheckBoxGroup.propTypes = {
    label: PropTypes.string.isRequired,
    displayValue: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    value: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
    clearAll: PropTypes.func,
    selectAll: PropTypes.func,
    active: PropTypes.bool,
    columnSize: PropTypes.number,
    isDropdown: PropTypes.bool,
    showValueAsTooltip: PropTypes.bool,
    tooltip: PropTypes.node,
};

export default RpCheckBoxGroup;